import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    {
        name: 'Пон',
        pv: 80,
    },
    {
        name: 'Вто',
        pv: 100,
    },
    {
        name: 'Сре',
        pv: 60,
    },
    {
        name: 'Чет',
        pv: 80,
    },
    {
        name: 'Пят',
        pv: 50,
    },
    {
        name: 'Суб',
        pv: 30,
    }
];

const Chart = () => {

    return (
        <ResponsiveContainer width="100%" height={200} >
            <BarChart
                data={data}
                margin={{
                    top: 0,
                    right: 10,
                    left: -25,
                    bottom: -8,
                }}
                
            >
                <ResponsiveContainer width="100%" height="100%" />
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dy={12} width={34} radius={4} dataKey="pv" fill="#03BDB3" />
            </BarChart>
        </ResponsiveContainer>
    );
}

export default Chart;